import React from 'react';

import LoginPage from '../web/pages/login/LoginPage';
import AuthComponent from '../web/components/AuthComponent';

import { BrowserRouter, HashRouter, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import DashboardPage from './pages/main/DashboardPage';

import '@fontsource/poppins/700.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import HousePage from './pages/house/HousePage';
import PriceListTablePage from './pages/price-list/PriceListsPage';
import HouseTablePage from './pages/house/HouseTablePage';
import PriceListPage from './pages/price-list/PriceListPage';
import HouseOffersPage from './pages/house-offer/HouseOffersPage';
import HouseOfferPage from './pages/house-offer/HouseOfferPage';
import CheckoutPage from './pages/reservation/checkout/CheckoutPage';
import BookingConfirmationPage from './pages/reservation/confirmation/BookingConfirmationPage';
import { HouseOfferSearchParamsProvider } from './pages/house-offer/context/HouseOfferSearchParamsContext';
import ReservationDetailsPage from './pages/reservation/details/ReservationDetailsPage';
import CalendarPage from './pages/house-calendar/CalendarPage';
import ReservationTablePage from './pages/reservation/list/ReservationTablePage';
import CustomersPage from './pages/customer/CustomersPage';
import CustomerReservationsPage from './pages/customer/CustomerReservationsPage';
import SettingsPage from './pages/settings/SettingsPage';
import PaymentTransactionsPage from './pages/transactions/TransactionsPage';
import HouseDetailsPage from './pages/house/HouseDetailsPage';
import { OfferProvider } from './context/OfferProvider';
import { GlobalConfigProvider } from './components/globalConfig/GlobalConfigContext';
import ReservationChangePage from './pages/reservation/checkout/ReservationChangePage';
import LegalDocumentTablePage from './pages/legal-document/LegalDocumentTablePage';
import LegalDocumentPage from './pages/legal-document/LegalDocumentPage';
import ActualLegalDocumentPage from './pages/legal-document/ActualLegalDocumentPage';
import PublicActualLegalDocumentPage from './pages/public/PublicActualLegalDocumentPage';
import PublicComingSoonPage from './pages/public/PublicComingSoonPage';
import CommonImagesPage from './pages/common-image/CommonImagesPage';

export default function App() {

  const isPublic = window.location.pathname.startsWith('/public');

  if (isPublic) {
    return <BrowserRouter>
      <Routes>
        <Route path="/public/legal-document/actual/:type" element={<PublicActualLegalDocumentPage />} />
        <Route path="/public/legal-document/preview/:id" element={<PublicActualLegalDocumentPage />} />
        <Route path="/public/coming-soon" element={<PublicComingSoonPage />} />
      </Routes>
    </BrowserRouter>;
  }

  return (
    <>
      <HashRouter
        future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
      >
        <HouseOfferSearchParamsProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              element={
                <GlobalConfigProvider>
                  <AuthComponent />
                </GlobalConfigProvider>
              }
            >
              <Route exact path="/" element={<DashboardPage />} />
              <Route exact path="/calendar" element={<CalendarPage />} />
              <Route exact path="/houses" element={<HouseTablePage />} />
              <Route exact path="/house-offer" element={<HouseOffersPage />} />
              <Route
                exact
                path="/house-offer/:id"
                element={
                  <OfferProvider>
                    <HouseOfferPage />
                  </OfferProvider>
                }
              />
              <Route
                exact
                path="/checkout/:id"
                element={
                  <OfferProvider>
                    <CheckoutPage />
                  </OfferProvider>
                }
              />
              <Route exact path="/house" element={<HousePage />} />
              <Route exact path="/house/:id" element={<HousePage />} />
              <Route
                exact
                path="/house/:id/details"
                element={<HouseDetailsPage />}
              />
              <Route
                exact
                path="/confirmation/:id"
                element={<BookingConfirmationPage />}
              />
              <Route
                exact
                path="/reservation/:id"
                element={<ReservationDetailsPage />}
              />
              <Route
                exact
                path="/reservation"
                element={<ReservationTablePage />}
              />
              <Route exact path="/customer" element={<CustomersPage />} />
              <Route
                exact
                path="/customer/:customerId/reservations"
                element={<CustomerReservationsPage />}
              />
              <Route
                exact
                path="/checkout/:id/:reservationId"
                element={
                  <OfferProvider>
                    <ReservationChangePage />
                  </OfferProvider>
                }
              />
              <Route
                exact
                path={'/price-lists'}
                element={<PriceListTablePage />}
              />
              <Route exact path={'/price-list'} element={<PriceListPage />} />
              <Route
                exact
                path={'/price-list/:id'}
                element={<PriceListPage />}
              />
              <Route
                exact
                path="/payment-transaction"
                element={<PaymentTransactionsPage />}
              />
              <Route
                exact
                path="/legal-documents"
                element={<LegalDocumentTablePage />}
              />
              <Route
                exact
                path="/common-images"
                element={<CommonImagesPage />}
              />
              <Route
                exact
                path="/legal-document"
                element={<LegalDocumentPage />}
              />
              <Route
                exact
                path="/legal-document/:id"
                element={<LegalDocumentPage />}
              />
              <Route
                exact
                path="/legal-document/actual/:type"
                element={<ActualLegalDocumentPage />}
              />
              <Route
                exact
                path="/legal-document/preview/:id"
                element={<ActualLegalDocumentPage />}
              />
              <Route exact path="/settings" element={<SettingsPage />} />
            </Route>
            <Route path="*" element={<DashboardPage />} />
          </Routes>
        </HouseOfferSearchParamsProvider>
      </HashRouter>
      <ToastContainer
        position="bottom-right"
        autoClose={2000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
}
